<template>
  <section class="app-main">
    <transition name="el-zoom-in-center" mode="out-in">
      <keep-alive >
        <router-view />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: "Child",
  data() {
    return {};
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.fullPath;
    }
  }
};
</script>